export enum UserType {
    Admin = 'Admin',
    User = 'User'
}